/*
 * Detect when after pay loads and move it from position
 */

 document.addEventListener("DOMContentLoaded", function () {
    console.log("DOM fully loaded and parsed");

    function whenAvailable(DOM_element, callback, number_of_trys = 0) {
        number_of_trys += 1;
        const appEl = document.querySelector(DOM_element)
        const interval = 1000; 
    
        //console.log( number_of_trys)
        const int = window.setTimeout(function() {
            if (appEl) {
                callback(appEl);
                clearInterval(int)
            } else {
            console.log(`Waiting for afterpay ${DOM_element} to be available...`);
            number_of_trys <= 10 ? whenAvailable(DOM_element, callback, number_of_trys) : console.log("Reached limit for number_of_trys DOM afterpay", number_of_trys);
            }
        }, interval);
    }
        
    whenAvailable("square-placement", function(el) {
        
      // console.log(el)
      const container = document.querySelector('[data-js-afterpay-container]')
      if(!container){
        return console.log('Cant find container to inser afterpay widget')
      }
      el.classList.add('fade-in')
      container.appendChild(el);

    },20);




});